import * as React from 'react';

import {classNames} from '@shopify/react-utilities/styles';
import {NOOP} from 'components/UIKit/utilities';
import {Button, ButtonProps, Icon} from 'components/UIKit';

import * as styles from './NavItem.scss';

interface NavItemProps extends ButtonProps {
  display?: 'button' | 'dropdown';
  itemProp?: string;
  label: string;
  element?: 'li' | 'div';
  url?: string;
  open?: boolean;
  className?: string | string[];
  tracking?: any;
  onClick?: () => any;
  onMouseMove?: (event) => any;
  onMouseLeave?: (event) => any;
}

export function NavItem(props: NavItemProps) {
  const {
    display,
    itemProp = 'name',
    label,
    element = 'li',
    url,
    open = false,
    className,
    onClick = NOOP,
    onMouseMove = NOOP,
    onMouseLeave = NOOP,
    tracking = {},
  } = props;

  let itemMarkup;

  if (display === 'button') {
    itemMarkup =
      <Button
        light
        url={url}
        label={label}
        itemProp={itemProp}
        onClick={onClick}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        {...tracking}
      />;
  } else if (display === 'dropdown') {
    itemMarkup =
      <button
        className={classNames(styles.navItemLink, styles.navItemDropdown, open && styles.open, className)}
        type="button"
        onClick={onClick}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        {...tracking}
      >
        {label}
        <Icon
          icon="dropdown"
          fill="white"
          size={20}
          className={styles.dropdownIcon}
          aria-hidden
        />
      </button>;
  } else {
    itemMarkup =
      <a
        className={classNames(styles.navItemLink, className)}
        href={url}
        itemProp={itemProp}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        {...tracking}
      >
        {label}
      </a>;
  }

  return React.createElement(
    element,
    {className: styles.navItem},
    itemMarkup,
  );
}

export default NavItem;
